import { useEffect, useState } from 'react';

import { logger } from '../logging/logger';

export const useTeams = () => {
	const [isValidating, setIsValidating] = useState(true);
	const [isTeams, setIsTeams] = useState(false);
	const [app, setApp] = useState(null);
	const [authentication, setAuthentication] = useState(null);

	useEffect(() => {
		const checkTeams = async () => {
			try {
				const { app, authentication } = await import('@microsoft/teams-js');
				await app.initialize();
				// @ts-expect-error
				setApp(app);
				// @ts-expect-error
				setAuthentication(authentication);
				setIsTeams(true);
				setIsValidating(false);
			} catch (err) {
				logger.debug('Not running in Teams context', { e: err });
				setIsTeams(false);
				setIsValidating(false);
			}
		};
		checkTeams();
	}, []);

	return { isTeams, app, authentication, isValidating };
};
